import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-inspector-dependencies',
  template: `
    <div class="deps-container">
      <nz-divider nzText="Dependências e Mapeamentos" nzOrientation="left"></nz-divider>
      <div class="deps-buttons">
        <button nz-button nzType="default" nzSize="small" (click)="onOpenDependencies.emit()">
          <nz-icon nzType="apartment" nzTheme="outline"></nz-icon> Dependências
        </button>
        <button nz-button nzType="default" nzSize="small" (click)="onOpenMappings.emit()">
          <nz-icon nzType="swap" nzTheme="outline"></nz-icon> Mapear
        </button>
      </div>
      <div class="deps-help" *ngIf="helpText">
        <nz-icon nzType="info-circle" nzTheme="outline" nz-tooltip [nzTooltipTitle]="helpText"
          style="color: #1890ff; cursor: help;"></nz-icon>
        <span>{{ helpText }}</span>
      </div>
    </div>
  `,
  styles: [`
    .deps-container {
      grid-column: 1 / -1;
      margin-top: 4px;
    }
    .deps-buttons {
      display: flex;
      gap: 6px;
    }
    .deps-buttons button {
      flex: 1;
    }
    .deps-help {
      display: flex;
      align-items: center;
      gap: 4px;
      margin-top: 4px;
      font-size: 11px;
      color: #8c8c8c;
      line-height: 1.3;
    }
  `]
})
export class InspectorDependenciesComponent {
  @Input() helpText = 'Dependências controlam habilitação. Mapeamentos propagam o valor deste campo.';
  @Output() onOpenDependencies = new EventEmitter<void>();
  @Output() onOpenMappings = new EventEmitter<void>();
}
